import { apiNewOnelink } from "net/requests";

import { User } from "model/user";
import { Onelink } from "model/onelink";

export interface Props {
  user?: User;
  onelinkList?: Onelink[];
  setOnelinkList: (onelinks: Onelink[]) => void;
  setOnelink: (onelink: Onelink) => void | boolean;
  setShowOnelinkEditor?: (b: boolean) => void;
}

export const newOnelink = (props: Props) => {
  const {
    user,
    onelinkList,
    setOnelinkList,
    setShowOnelinkEditor,
    setOnelink,
  } = props;

  apiNewOnelink(user as User)
    .then((response) => {
      const createdOnelink = response.data;
      const newList = [...(onelinkList || []), createdOnelink];
      setOnelinkList(newList);
      const selected = setOnelink && setOnelink(createdOnelink);
      if (selected) setShowOnelinkEditor && setShowOnelinkEditor(true); // auto open editor
    })
    .catch((error) => {
      console.log(error.response?.data?.error);
    });
};
